module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-18.056ac69e.png";